"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIFireAlarm;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIAlert = _interopRequireDefault(require("../alert/UIAlert"));

function UIFireAlarm(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(_UIAlert.default, Object.assign({}, rest, {
    className: (0, _classnames.default)('private-alert--system-wide', className)
  }));
}

UIFireAlarm.propTypes = Object.assign({}, _UIAlert.default.propTypes, {
  type: _propTypes.default.oneOf(['danger', 'info', 'warning']).isRequired
});
UIFireAlarm.defaultProps = Object.assign({}, _UIAlert.default.defaultProps, {
  type: 'warning'
});
UIFireAlarm.displayName = 'UIFireAlarm';
module.exports = exports.default;